const _ = require('underscore');

class ContractStageController {
  constructor($scope, ApplicationService) {
    this.$scope = $scope;
    this.ApplicationService = ApplicationService;

    this.$scope.showPaymentMethod = this.showPaymentMethod.bind(this);
  }

  showPaymentMethod(method) {
    return _.contains(
      this.ApplicationService.data.customer_application.payment_method_options,
      method
    );
  }
}

ContractStageController.$inject = ["$scope", "ApplicationService"];

export default ContractStageController;
